import { z } from 'zod';

export const supportRequestSchema = z.object({
  Title: z.string().min(1),
  Priority: z.string(),
  Category: z.string(),
  For_idUser: z.number(),
  Description: z.string(),
  ticket_id: z.number().optional(),
});

export type ISupportRequest = z.infer<typeof supportRequestSchema>;

export const getInitialSupportRequest = (): ISupportRequest => {
  return {
    Title: '',
    Priority: 'support-middle',
    Category: 'support-error',
    For_idUser: Number(localStorage.getItem('idUser')),
    Description: '',
  };
};
